// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import getProp from "@insite/mobius/utilities/getProp";
import { signInExistingAccountStyles } from "@stanion/Overrides/Widgets/SignIn/SignInExistingAccount";
import { color } from "@stanion/XDL/Utilities";
import { css } from "styled-components";

signInExistingAccountStyles.signInButtonGridItem = {
    width: 12,
};

signInExistingAccountStyles.rememberMeCheckbox = {
    css: css`
        margin-left: 15px;
    `,
};

signInExistingAccountStyles.forgotPasswordGridItem = {
    width: 6,
    css: css`
        justify-content: flex-end;
        align-items: center;
    `,
};

signInExistingAccountStyles.forgotPasswordLink = {
    typographyProps: {
        size: 13,
    },
    css: css`
        margin-right: 15px;
    `,
};

signInExistingAccountStyles.resetPasswordModal = {
    sizeVariant: "small",
    cssOverrides: {
        scrim: css`
            z-index: ${getProp("theme.zIndex.resetPasswordModal")};
        `,
    },
};

signInExistingAccountStyles.titleWrapper = {
    css: css`
        ${({ isMiniSignIn }: any) =>
            isMiniSignIn &&
            css`
                background-color: ${color("common.ui8", 0.1)};
                color: ${color("text.main")};
                font-size: 22px;
                font-weight: bold;
                letter-spacing: 0;
                line-height: 30px;
                width: 100%;
                height: 55px;
                padding: 0 16px;
                display: flex;
                align-items: center;
            `}
    `,
};

signInExistingAccountStyles.signInExistingAccountTitle = {
    variant: "h4",
    css: css`
        ${({ isMiniSignIn }: any) =>
            isMiniSignIn &&
            css`
                font-size: 18px;
                font-weight: bold;
                line-height: 22px;
                margin-bottom: 0;
            `}
    `,
};

signInExistingAccountStyles.form = {
    css: css`
        ${({ isMiniSignIn }: any) =>
            isMiniSignIn
                ? `                     
    width: 500px;
    padding: 15px 15px 0 15px;
    `
                : ""}
    `,
};

signInExistingAccountStyles.rememberMeGridItem = {
    width: 6,
    ...({ isMiniSignIn }: any) =>
        isMiniSignIn && {
            css: css`
                ${signInExistingAccountStyles.rememberMeGridItem?.css}
                flex-direction: row;
            `,
        },
};
